






















import Vue from "vue";
import { action, store } from "../../services/store";
import { IMyPrizeItem } from "@/types";
import { getScheme, openScheme } from "@/utils/openUrl";
import { redbagPageUrl } from "@/utils/config";

import BottomDialog from "../dialog/BottomDialog.vue";
import PrizesComp from "../PrizesComp.vue";

export default Vue.extend({
  components: {
    BottomDialog,
    PrizesComp
  },
  computed: {
    prizeList(): IMyPrizeItem[] {
      return store.myPrizeList;
    }
  },
  methods: {
    updatePrizes() {
      action.updatePrizes();
    },
    getScrollableElement() {
      return document.querySelector(".my-prizes .content-box");
    },
    getBtnClass() {
      return "plain";
    },
    getBtnText(item: IMyPrizeItem) {
      const { award_type } = item;
      if (award_type === "Cash") {
        return "已入账";
      } else {
        return "已兑换";
      }
    },
    jumpUrl(item: IMyPrizeItem) {
      const { award_type, jump_url, source } = item;
      // 如果是拉新红包
      if (award_type === "Cash" && source === 2) {
        const scheme = getScheme("browser", redbagPageUrl);
        openScheme(scheme);
      } else {
        if (jump_url) {
          const scheme = getScheme("browser", jump_url);
          openScheme(scheme);
        }
      }
    }
  }
});
